import { FC } from 'react';
import {
    Alert as FlowbiteAlert,
    AlertProps as FlowbitAlertProps,
    createTheme,
} from 'flowbite-react';
import {
    Icon as TablerIcon,
    IconAlertCircle,
    IconInfoCircle,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
    alert: {
        wrapper: 'flex gap-2 justify-between',
        icon: 'min-w-4 min-h-4',
    },
}).alert;

type Props = {
    message: 'no-sites' | 'service-error';
};

type NoticeData = {
    text: string;
    icon: TablerIcon;
    color: FlowbitAlertProps['color'];
} | null;

export const useNoticeData = (message: Props['message']): NoticeData => {
    const { t } = useTranslation('navigation', {
        keyPrefix: 'site_selector.lists.notice',
    });

    switch (message) {
        default:
            return null;
        case 'no-sites':
            return {
                text: t('no_sites'),
                icon: ({ ...props }) => <IconInfoCircle {...props} />,
                color: 'info',
            };
        case 'service-error':
            return {
                text: t('service_error'),
                icon: ({ ...props }) => <IconAlertCircle {...props} />,
                color: 'failure',
            };
    }
};

export const SiteSelectorNotice: FC<Props> = ({ message }) => {
    const noticeData = useNoticeData(message);

    if (!noticeData) return null;

    const { text, icon: Icon, color } = noticeData;

    return (
        <FlowbiteAlert
            theme={theme}
            color={color}
            icon={() => <Icon size={16} className="min-w-4 min-h-4" />}
        >
            <span>{text}</span>
        </FlowbiteAlert>
    );
};
